import { Routes, Route } from 'react-router-dom';
import { Layout } from './shared/components/Layout';
import Home from './pages/Home/Home';
import Episodes from './pages/Episodes/Episodes';
import EpisodeDetail from './pages/EpisodeDetail/EpisodeDetail';
import About from './pages/About/About';
import Community from './pages/Community/Community';
import NotFound from './pages/NotFound/NotFound';

function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/episodes" element={<Episodes />} />
        <Route path="/episodes/:id" element={<EpisodeDetail />} />
        <Route path="/about" element={<About />} />
        <Route path="/community" element={<Community />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

export default App;
